import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Father's Day 2026 promo popup.
// Shows every site visit from now until the end of Father's Day (Sun June 21, 2026)
// in Pacific time. June is PDT (UTC-7), so end-of-day Pacific = 2026-06-22T07:00:00Z.
const FATHERS_DAY_END_UTC = Date.UTC(2026, 5, 22, 7, 0, 0); // June 22, 2026 07:00 UTC

const FathersDayPopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (Date.now() <= FATHERS_DAY_END_UTC) {
      setShowPopup(true);
    }
  }, []);

  const handleClose = () => {
    // No localStorage — shows on every visit during the promo window.
    setShowPopup(false);
  };

  return (
    <AnimatePresence>
      {showPopup && (
        <motion.div
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleClose}
        >
          <motion.div
            className="relative w-full max-w-sm overflow-hidden shadow-2xl rounded-lg"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: 'spring', damping: 30 }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              onClick={handleClose}
              className="absolute top-3 right-3 z-10 bg-black/40 hover:bg-black/60 text-white rounded-full p-2 transition-colors"
              aria-label="Close popup"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>

            <img
              src="/assets/images/fathers-day-popup.png"
              alt="Make Dad's Day — 50% off Beer & Wine Bottles, Sunday June 21st only"
              className="w-full h-auto block"
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FathersDayPopup;
